import React, { FC } from 'react'
import { LocaleCurrency } from 'components/FormatPrice'
import { convertFromCentsToDollars } from 'components/FormatPrice/helpers'
import ProductOriginalConnector, {
  ConnectorProps as ProductOriginalProps,
} from '../../../connectors/ProductsOriginal'
import { Row } from '../../styles/products'
import { DiscountBannerWrapper } from '../../styles'
import { FOR_SALE } from '../../../helpers/constants'
import InfoCircle from 'svg/info-circle.svg'
import useQA from 'hooks/useQA'
const DiscountBanner: FC<ProductOriginalProps> = (props) => {
  const { productStatus, listPrice, promoCode, promoDiscount } = props
  const { testId } = useQA()
  const discountedPrice = (1 - promoDiscount / 100) * listPrice

  if (productStatus !== FOR_SALE || promoDiscount === 0) {
    return null
  }

  return (
    <>
      <Row>
        <DiscountBannerWrapper {...testId('discount-price-banner')}>
          <InfoCircle />
          <h6 className='defaultTypographyH6'>
            <LocaleCurrency price={convertFromCentsToDollars(discountedPrice)} /> With Code{' '}
            {promoCode}
          </h6>
        </DiscountBannerWrapper>
      </Row>
    </>
  )
}

export default ProductOriginalConnector(DiscountBanner)
